import { useState, useEffect } from 'react';

export default function useMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    let timer = null;
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    const debounced = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(handleResize, 150);
    };
    window.addEventListener('resize', debounced);
    return () => { if (timer) clearTimeout(timer); window.removeEventListener('resize', debounced); };
  }, [breakpoint]);

  return isMobile;
}
